import * as React from 'react';
import classnames from 'classnames';
import { IconCloseThin, IconMenu } from '../Icons';
import injectStyles from '../jss';
import styles from './MenuButton.jss';
var MenuButton = function MenuButton(_ref) {
  var classes = _ref.classes,
    className = _ref.className,
    isMenuOpen = _ref.isMenuOpen,
    menuButtonText = _ref.menuButtonText,
    toggleMenu = _ref.toggleMenu;
  if (isMenuOpen) {
    return React.createElement(IconCloseThin, {
      className: classnames(classes.menu, className, 'close'),
      onClick: toggleMenu
    });
  }
  if (menuButtonText) {
    return React.createElement("button", {
      className: classnames(classes.menu, className, 'button'),
      onClick: toggleMenu
    }, menuButtonText);
  }
  return React.createElement(IconMenu, {
    className: classnames(classes.menu, className, 'burger'),
    onClick: toggleMenu
  });
};
MenuButton.styleRoot = 'MenuButton';
export default injectStyles(styles)(MenuButton);